<div class="flex justify-center flex-1">
    <div class="flex h-full mx-10 mobile:mx-2 flex-1" style="justify-content: center !important;">
        <!-- *ngIf='galleryImages.length>0' -->
        <ng-container>
        <ngx-gallery [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
      </ng-container>
    </div>
  </div>
  